// extracted by mini-css-extract-plugin
export var container = "SupplementaryDataSubForm-module__container___sud7q";
export var contentRow = "SupplementaryDataSubForm-module__contentRow___Stqw3";
export var dynamicContainer = "SupplementaryDataSubForm-module__dynamicContainer___Ulu-x";
export var field = "SupplementaryDataSubForm-module__field___bOYW+";
export var gameDevelopersColumn = "SupplementaryDataSubForm-module__gameDevelopersColumn___0ncwt";
export var large = "1084px";
export var medium = "860px";
export var small = "540px";